import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BiFinanceiroService {
	private url: string = environment.g2e_api;

	constructor(private http: HttpClient) { }

	// empresa: 'rastreei' ou 'faleflex'; inicio e fim: competência AAAA-MM (sem eles, a API usa os 2 últimos meses).
	public getDashboard(empresa: string, inicio?: string, fim?: string): Observable<{ statusCode: number, message: string[], data: any }> {
		let params = new HttpParams();
		if (inicio && fim) {
			params = params.set('inicio', inicio).set('fim', fim);
		}
		return this.http.get<{ statusCode: number, message: string[], data: any }>(`${this.url}bi-financeiro/${empresa}`, {
			headers: new HttpHeaders({
				'Content-Type': 'application/json; charset=UTF-8',
				'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
			}),
			params,
		});
	}
}
